// The brand mark, inline so it needs no image request and can respond to the
// theme. Same artwork as public/favicon.svg: a moped ("Mopped") riding the
// route with its packets on board — and one that bounced off the back. Keep
// the two in sync when the mark changes.

export function Logo({ size = 30, className }: { size?: number; className?: string }) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 512 512"
      role="img"
      aria-hidden="true"
      focusable="false"
    >
      <defs>
        <linearGradient id="plm-logo-sky" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#6fdcf2" />
          <stop offset="0.55" stopColor="#0f9fd6" />
          <stop offset="1" stopColor="#0a6b99" />
        </linearGradient>
        <radialGradient id="plm-logo-lime" cx="0.86" cy="0.9" r="0.55">
          <stop offset="0" stopColor="#9be86a" stopOpacity="0.55" />
          <stop offset="1" stopColor="#9be86a" stopOpacity="0" />
        </radialGradient>
        <linearGradient id="plm-logo-gloss" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#ffffff" stopOpacity="0.62" />
          <stop offset="1" stopColor="#ffffff" stopOpacity="0.06" />
        </linearGradient>
        <linearGradient id="plm-logo-lamp" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#d7ff9e" />
          <stop offset="1" stopColor="#7bd34f" />
        </linearGradient>
        <linearGradient id="plm-logo-loss" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#ff9a82" />
          <stop offset="1" stopColor="#e8503f" />
        </linearGradient>
      </defs>

      {/* glass tile; the fx layers are hidden under the high-contrast theme */}
      <rect width="512" height="512" rx="112" fill="url(#plm-logo-sky)" className="logo__tile" />
      <rect width="512" height="512" rx="112" fill="url(#plm-logo-lime)" className="logo__fx" />
      <path
        d="M0 112 A112 112 0 0 1 112 0 H400 A112 112 0 0 1 512 112 V228 C400 280 112 280 0 228 Z"
        fill="url(#plm-logo-gloss)"
        className="logo__fx"
      />

      <g transform="translate(10 -26)">
        {/* the route: dashed, one dash per hop */}
        <path
          d="M64 420 H448"
          stroke="#ffffff"
          strokeOpacity="0.55"
          strokeWidth="14"
          strokeLinecap="round"
          strokeDasharray="34 26"
          fill="none"
        />

        {/* wheels */}
        <g fill="none" stroke="#ffffff" strokeWidth="26">
          <circle cx="156" cy="356" r="50" />
          <circle cx="372" cy="356" r="50" />
        </g>
        <circle cx="156" cy="356" r="14" fill="#ffffff" />
        <circle cx="372" cy="356" r="14" fill="#ffffff" />

        {/* body: fender, rear cowl + seat, floorboard, leg shield, handlebar, rack + cargo */}
        <g fill="#ffffff" stroke="#2fb1e2" strokeWidth="6" strokeLinejoin="round">
          <path d="M316.8 309.7 A72 72 0 0 1 427.2 309.7" fill="none" stroke="#ffffff" strokeWidth="20" strokeLinecap="round" />
          <ellipse cx="200" cy="278" rx="70" ry="46" />
          <rect x="150" y="224" width="104" height="28" rx="14" />
          <rect x="236" y="318" width="100" height="24" rx="12" />
          <rect x="316" y="206" width="44" height="132" rx="22" />
          <rect x="292" y="194" width="104" height="22" rx="11" />
          <rect x="100" y="236" width="52" height="14" rx="7" />
          <rect x="106" y="198" width="38" height="38" rx="9" />
        </g>
        {/* headlight */}
        <circle cx="338" cy="250" r="16" fill="url(#plm-logo-lamp)" />

        {/* the packet that fell off */}
        <g transform="translate(64 296) rotate(-22)">
          <rect x="-26" y="-26" width="52" height="52" rx="13" fill="url(#plm-logo-loss)" stroke="#ffffff" strokeWidth="6" />
        </g>
      </g>
    </svg>
  );
}
